import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import usePageSeo from '@/hooks/usePageSeo';
import { getByCategory } from '@/mocks/anime';
import CategoryLayout, { type CategoryTab } from '../components/CategoryLayout';

const tabs: CategoryTab[] = [
  { key: 'all', label: '全部' },
  { key: '清新', label: '清新治愈' },
  { key: '催泪', label: '催泪暖心' },
  { key: '暖心', label: '家庭亲情' },
];

const title = '治愈番专区';
const description =
  '在牛奶动漫库治愈番专区，精选催泪暖心、清新自然的治愈系动画，无论你想放松心情还是被温柔治愈，都能在这里找到下一部心头好。';

export default function Healing() {
  usePageSeo({
    title: `牛奶动漫库${title} - 治愈番推荐、催泪暖心补番`,
    description,
    keywords: '牛奶动漫库,治愈番推荐,催泪动画,清新治愈,温馨补番',
    canonical: 'https://cartoplist.github.io/category/healing',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `${title} - 牛奶动漫库`,
        url: 'https://cartoplist.github.io/category/healing',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://cartoplist.github.io/' },
          { '@type': 'ListItem', position: 2, name: title, item: 'https://cartoplist.github.io/category/healing' },
        ],
      },
    ],
  });

  return (
    <>
      <Navbar />
      <CategoryLayout
        category="healing"
        eyebrow="治愈系补番目录"
        title={title}
        subtitle={description}
        items={getByCategory('healing')}
        tabs={tabs}
      />
      <Footer />
      <BackToTop />
    </>
  );
}